// import { } from 'core/modules/chat/actions';
import { initialState } from 'core/modules/initialState';

export default function chat(state = initialState.chat, action = {}) {
  const { type, payload } = action;

  switch (type) {
    default: {
      return state;
    }
  }
}
